export enum StarBucksFeatureFlags {
    BillOtherPaymentsAdjustmentsEnabled = 'bill-other-payments-adjustments-enabled',
    ChangeShiftStatusWhenUnitsOff = 'enable-change-shift-status-when-enable-units-off',
    DisableDeleteOtherPaymentsIfClientInvoiceProcessed = 'disable-delete-other-payments-if-client-invoice-processed',
    InvoiceLinesUnitLookupFix = 'enable-invoice-unit-lookup-fix',
    InvoicesViewAsStandalone = 'invoices-view-as-standalone',
    PreferredOvertimeEnabled = 'preferred-overtime-enabled',
    PreventBrowserTabSleep = 'prevent-browser-tab-sleep',
    PreventDuplicateSignalRConnections = 'prevent-duplicate-signalr-connections',
    TimecardImportErrorsGridCleanup = 'timecard-import-errors-grid-cleanup',
    TimecardImportErrorsOverlappingShifts = 'timecard-import-errors-overlapping-shifts',
    TimecardSyncV2 = 'timecard-sync-v2',
    ReverseInvoiceExportPerformanceImprovements = 'reverse-invoice-export-performance-improvements'
}
